var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"epoq-gift-list"},on:{"activate-gift-list":_vm.activateGiftList}},[(_vm.hasGiftList)?_c('GiftList',{attrs:{"giftList":_vm.giftListComputed}}):_vm._e(),(_vm.showClubModal)?_c('GiftListClubModal',{attrs:{"clubDiscount":_vm.clubDiscount}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }